import intl from 'react-intl-universal'
export const satisfactionList = [
  {
    title: intl.get('qrcode.signIn.question1'),
    satisfaction: 0
  },
  {
    title: intl.get('qrcode.signIn.question2'),
    satisfaction: 0
  },
  {
    title: intl.get('qrcode.signIn.question3'),
    satisfaction: 0
  },
  {
    title: intl.get('qrcode.signIn.question4'),
    satisfaction: 0
  },
  {
    title: intl.get('qrcode.signIn.question5'),
    satisfaction: 0
  },
]